module.exports = __webpack_public_path__ + "static/media/minus_orange.b73e9285.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/minus_orange.png
 ** module id = 75
 ** module chunks = 0
 **/